import React from "react";
import { notify } from "@/shared/utils/notify";
import { rulesSushiLunchService } from "../../../shared/services";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { SelectedDaysType } from "../ui";

export const useCreateRulesSushiLunch = ({
  setOpenModalCreate,
  days,
}: {
  setOpenModalCreate: (val: boolean) => void;
  days: SelectedDaysType;
}) => {
  const [loading, setLoading] = React.useState<boolean>(false);

  const {
    control,
    handleSubmit: onSubmit,
    reset,
    watch,
    setValue,
  } = useForm<any>({
    resolver: yupResolver(
      yup.object({
        name: yup.string().required("Campo requerido"),
        apply_to: yup.string().required("Campo requerido"),
        start_time: yup.string().required("Campo requerido"),
        end_time: yup.string().required("Campo requerido"),
      })
    ),
  });

  const handleSubmit = onSubmit(async (data: any) => {
    if (loading) return;

    setLoading(true);
    await rulesSushiLunchService
      .create({
        ...data,
        monday: days.monday,
        tuesday: days.tuesday,
        wednesday: days.wednesday,
        thursday: days.thursday,
        friday: days.friday,
        saturday: days.saturday,
        sunday: days.sunday,
      })
      .then((_res: any) => {
        notify.success(`Se ha creado la regla exitosamente`);
        setOpenModalCreate(false);
        reset({});
      })
      .catch((err: any) => {
        notify.error(err.message);
        return err.message;
      })
      .finally(() => {
        setLoading(false);
      });
  });

  return {
    loading,
    control,
    handleSubmit,
    watch,
    setValue,
  };
};
